import { useNavigate } from "react-router-dom";
import FeaturesSection from "./Features";
import { motion } from 'framer-motion';
import Footer from "../../Component/Fooder";

const HealthPlans = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* <div className="p-8  bg-gradient-to-t from-[#78ffa5] to-[#03ab3b]   w-full"> */}
      <div className="p-8  bg-white   w-full">
        {/* <h1 className=" mt-3 font-bold  text-white text-center mb-4 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"></h1> */}
        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="px-6 mb-2 text-center text-[30px] font-bold text-gray-800 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"
        >
           HikeHealth GS –Patient-Centered Software Solutions
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Feature 1 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
            {/* <FaRegHospital className="text-blue-500 text-3xl mb-3" /> */}
            <h2 className="text-center font-bold">Comprehensive Coverage</h2>
            <p className="text-gray-600 text-xs mt-2">
            Access a wide range of healthcare services, from routine checkups to specialized treatments, all managed through integrated software solutions that enhance patient care.
            </p>
            <div className="-mb-12">
              <button
                onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/Comprehensive')}
                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                Read More
              </button>
            </div>


          </div>

          {/* Feature 2 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
            {/* <FaShieldAlt className="text-green-500 text-4xl mb-2" /> */}
            <h2 className="text-lg font-bold">Secure & Affordable</h2>
            <p className="text-gray-600 text-xs mt-2">
            We offer secure, affordable healthcare plans that prioritize patient care while ensuring financial security for you and your family.
            </p>
            <div className="-mb-12">
 
              <button onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/Secure&Affordable')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Easy Claims Processing</h2>
            <p className="text-gray-600 text-xs mt-2">
            Streamline claims processing with digital documentation and instant approval systems that eliminate paperwork and accelerate reimbursement cycles.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/Easyclams')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>

          {/* CMS Mandates */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col justify-between items-center text-center">
            {/* <FaClipboardCheck className="text-purple-500 text-6xl mb-2" /> */}
            <h2 className="text-lg font-bold">CMS Mandates </h2>
            <p className="text-gray-600 text-xs ">
            Our solutions ensure compliance with CMS (Centers for Medicare & Medicaid Services) mandates, aligning with regulatory guidelines for healthcare interoperability and operational efficiency.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/Cms')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
           
            <h2 className="text-lg font-bold"> Role at Blue Button2.0</h2>
            <p className="text-gray-600 text-xs ">
              Compliance and regulatory guidelines for healthcare interoperability and efficiency.
            </p>
            <div className="-mb-12">

              <button
                onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/BlueButtons')}
                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                Read More
              </button>
            </div>

          </div> */}

          {/* Consent Management */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
            {/* <FaUsersCog className="text-pink-500 text-5xl mb-4" /> */}
            <h2 className="text-lg font-bold">Consent Management</h2>
            <p className="text-gray-600 text-xs ">
            We ensure patient data privacy with efficient consent management protocols, maintaining compliance with healthcare regulations and empowering patients to control their information.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/Consentmanagement')}
                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
                before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>

          {/* Interoperability Platform  */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col justify-between items-center text-center">
            {/* <FaExchangeAlt className="text-orange-500 text-5xl mb-4" /> */}
            <h2 className="text-lg font-bold">Interoperability </h2>
            <p className="text-gray-600 text-xs ">
            Facilitating seamless healthcare data exchange between providers and payers, ensuring that patient information is securely shared across different healthcare systems to improve care coordination.
            </p>
            <div className="-mb-12">
              <button onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/Interoperability')}
                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Interoperability Platform*/}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col justify-between items-center text-center">
            <h2 className="text-lg font-bold">Payer-to-Payer</h2>
            <p className="text-gray-600 text-xs">Enhancing the flow of data between payers and providers for streamlined billing and claims processing, reducing administrative overhead and improving accuracy.</p>
            <div className="-mb-12">
              <button
                onClick={() => navigate('/Services/Patient-CenteredSoftwareSolutions/Payer')}
                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                Read More
              </button>
            </div>
          </div>
        </div>


        <div><FeaturesSection /></div>
      </div>
      <Footer />
    </>
  );
};

export default HealthPlans;
